import { motion } from 'framer-motion';
import { Lock, LogOut, Clock } from 'lucide-react';
import { Button } from '@/components/ui/button';

const LOGO_ICON = 'https://static.prod-images.emergentagent.com/jobs/85ba9bbd-736c-4dbb-ae2d-37b84f64fb5b/images/46c4c99dc82a03ab2b247ccff337db0bc40f8a2e674401b4d8deca221940954b.png';

export default function LockedAccount({ parent, onLogout }) {
  return (
    <div
      className="min-h-screen font-[Nunito] flex flex-col"
      style={{ background: 'linear-gradient(135deg, #FFFBF5 0%, #FFF7ED 50%, #FEF3C7 100%)' }}
    >
      {/* Header */}
      <div className="bg-white/70 backdrop-blur-xl border-b border-orange-100/50 px-4 sm:px-6 py-3">
        <div className="max-w-5xl mx-auto flex items-center justify-between">
          <div className="flex items-center gap-2.5">
            <img src={LOGO_ICON} alt="Yukti" className="w-8 h-8" />
            <span className="text-xl font-bold text-[#1F2937] font-[Outfit]">Yukti</span>
          </div>
          <Button
            onClick={onLogout}
            variant="ghost"
            className="text-[#9CA3AF] hover:text-red-500 text-sm"
            data-testid="locked-logout-btn"
          >
            <LogOut className="w-4 h-4 mr-1.5" /> Sign Out
          </Button>
        </div>
      </div>

      {/* Main content */}
      <div className="flex-1 flex items-center justify-center px-4 py-12">
        <motion.div
          initial={{ opacity: 0, scale: 0.95, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          className="bg-white rounded-3xl p-8 sm:p-10 max-w-md w-full shadow-xl border border-orange-100 text-center"
          data-testid="locked-account-card"
        >
          <div className="w-20 h-20 mx-auto mb-5 bg-gradient-to-br from-red-500 to-orange-600 rounded-2xl flex items-center justify-center shadow-lg">
            <Lock className="w-10 h-10 text-white" />
          </div>

          <h1 className="text-2xl sm:text-3xl font-bold text-[#1F2937] font-[Outfit] mb-2">
            Trial Period Ended
          </h1>
          <p className="text-[#6B7280] text-sm sm:text-base mb-6 leading-relaxed">
            Hi {parent?.name?.split(' ')[0] || 'there'}, your 7-day free trial has ended. 
            Your account is currently on hold.
          </p>

          <div className="bg-[#FFF7ED] border border-orange-200 rounded-xl p-4 mb-6">
            <div className="flex items-center justify-center gap-2 mb-2">
              <Clock className="w-4 h-4 text-[#C2410C]" />
              <span className="text-sm font-semibold text-[#C2410C]">What happens now?</span>
            </div>
            <p className="text-xs text-[#6B7280] leading-relaxed">
              Your data is safe and will be preserved. We'll be launching subscription plans soon 
              so you can continue your child's learning journey with Yukti.
            </p>
          </div>

          <div className="bg-gray-50 rounded-xl p-4 mb-6">
            <p className="text-xs text-[#9CA3AF]">
              Logged in as <span className="font-semibold text-[#4B5563]">{parent?.email}</span>
            </p>
          </div>

          <Button
            onClick={onLogout}
            className="w-full bg-[#C2410C] hover:bg-[#9A3412] text-white rounded-xl py-5 font-bold"
            data-testid="locked-signout-btn"
          >
            <LogOut className="w-4 h-4 mr-2" /> Sign Out
          </Button>
        </motion.div>
      </div>
    </div>
  );
}
